import { IntegrationsContainer } from "modules/integrations/containers";

export const IntegrationsSettingsRoute = () => {
  return <IntegrationsContainer />;
};
